import { OptionDto } from "@/dtos";
import { PlanType } from "@/helpers/types";

const planTypes = [
    { value: PlanType.CUMULATIVE_PERCENTAGE, label: 'Porcentaje Acumulado' },
] as OptionDto[];

export const getPlanTypeOptions = (): OptionDto[] => {
    return planTypes;
}

export const getPlanTypeOption = (value?: number): OptionDto => {
    return planTypes.find((x) => x.value == value) ?? planTypes[0];
}

export const getPlanTypeLabel = (value: number): string => {
    return planTypes.find((x) => x.value == value)?.label ?? planTypes[0].label;
}